import React from 'react';

const SvgComponent = props => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M11.77 14.16a5 5 0 1 0-5.54 0A5.5 5.5 0 0 0 2 19.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5 5.5 5.5 0 0 0-4.23-5.34zM5 10a4 4 0 1 1 4 4 4 4 0 0 1-4-4zm-2 9a4.5 4.5 0 0 1 4.5-4h3a4.5 4.5 0 0 1 4.5 4zM21.18 10.17c-.41-.23-1.11-.33-2.18.37-1.07-.7-1.77-.6-2.18-.37a2 2 0 0 0-.81 2A4.48 4.48 0 0 0 18.84 16a.45.45 0 0 0 .16 0 .45.45 0 0 0 .16 0A4.48 4.48 0 0 0 22 12.21a2 2 0 0 0-.82-2.04zM21 12.12A3.58 3.58 0 0 1 19 15a3.58 3.58 0 0 1-2-2.88c-.05-.53.07-.95.29-1.07s.79 0 1.4.5a.47.47 0 0 0 .3.1.47.47 0 0 0 .3-.1c.61-.46 1.14-.65 1.4-.5s.31.54.31 1.07z" />
    </svg>
);

export default SvgComponent;
